var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isNewButton)?_c('button',{staticClass:"vbutton",class:[
    _vm.type ? `type-${_vm.type}` : '',
    _vm.color,
    _vm.text_color ? `text-${_vm.text_color}` : '',
    _vm.hover_color ? `hover-${_vm.hover_color}` : '',
    _vm.bg_color ? `bg-${_vm.bg_color}` : '',
    _vm.icon ? _vm.icon : '',
    _vm.icon_last ? 'icon-last' : '',
    _vm.size ? `size-${_vm.size}` : '',
    _vm.block ? 'block' : '',
    { iconed: _vm.icon },
    { disabled: _vm.disabled },
    { loading: _vm.loading },
    { padding_min: _vm.padding_min }
  ],attrs:{"disabled":_vm.disabled},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==13)return null;$event.preventDefault();return _vm.emit.apply(null, arguments)},"click":function($event){$event.preventDefault();return _vm.emit.apply(null, arguments)}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"button-label"},[(_vm.icon && !_vm.icon_last)?_c('span',{staticClass:"button-icon"}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.button_label)+"\n    "),(_vm.icon && _vm.icon_last)?_c('span',{staticClass:"button-icon"}):_vm._e()]),_vm._v(" "),_vm._t("default")],2):_c('button',{staticClass:"vbutton-new"},[_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader"},[_c('span',{staticClass:"loading-spinner"})])
}]

export { render, staticRenderFns }